import { BOMItemType } from '../../constants/bom-item-type.js';
/** Whether a BOM line carries a cost although only a charge (SERVICE) line may. */
export const isCostOnNonChargeLine = (values) => values.cost != null && values.typeId !== BOMItemType.SERVICE;
//# sourceMappingURL=is-cost-on-non-charge-line.js.map